import * as mutations from "../../graphql/mutations";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { apiClient } from "../../helpers/apiClient";
import { useAuthInfo } from "../../helpers/useAuthInfo";
import { useTranslation } from "react-i18next";
import {
  Box,
  Divider,
  IconButton,
  Modal,
  TextField,
  Typography,
} from "@mui/material";

export default function CreateUpdatePublicAssessmentModal({
  open,
  setOpen,
  editAssessmentData,
  setEditAssessmentData,
  setNotificationMessage,
  setOpenNotification,
  fetchData,
}) {
  const { t } = useTranslation();
  const { userGroups } = useAuthInfo();

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    maxWidth: 0.95,
    minWidth: 500,
    borderRadius: 5,
    boxShadow: 24,
    p: 2,
  };

  async function createUpdatePublicAssessment() {
    try {
      const assessmentName =
        editAssessmentData?.name || editAssessmentData?.title || "";

      if (editAssessmentData?.id) {
        await apiClient.graphql({
          query: mutations.updateAssessment,
          variables: {
            input: {
              id: editAssessmentData.id,
              name: assessmentName,
            },
          },
        });
        setNotificationMessage(t("updatedAssessment"));
      } else {
        await apiClient.graphql({
          query: mutations.createAssessment,
          variables: {
            input: {
              name: assessmentName,
              type: "STANDARD",
              active: false,
              public: true,
              language: "DE",
              ownerGroups: userGroups,
            },
          },
        });
        setNotificationMessage(t("createdAssessment"));
      }
      try {
        await fetchData();
      } catch (e) {
        console.error(e);
      }
    } catch (e) {
      console.error(e);
      setNotificationMessage(t("errorMessage"));
    }
    setOpen(false);
    setOpenNotification(true);
  }

  return (
    <div>
      <Modal
        open={open}
        // onClose={() => {
        //   setOpen(false);
        // }}
        disableAutoFocus={true}
      >
        <Box sx={style}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography sx={{ fontSize: 17 }}>
                {!editAssessmentData?.id
                  ? t("createAssessment")
                  : t("editAssessment")}
              </Typography>
              <IconButton onClick={() => setOpen(false)}>
                <CloseIcon />
              </IconButton>
            </Box>
            <Divider sx={{ my: 1 }} />
            {editAssessmentData?.id && (
              <Typography>Assessment Id: {editAssessmentData.id}</Typography>
            )}
            <TextField
              color="secondary"
              InputLabelProps={{
                shrink: true,
              }}
              label={"Title"}
              variant="outlined"
              size="small"
              sx={{ width: 300, mt: 3, ml: 2 }}
              value={
                editAssessmentData?.name || editAssessmentData?.title || ""
              }
              onChange={(event) => {
                setEditAssessmentData((prev) => ({
                  ...(prev || {}),
                  name: event.target.value,
                  title: event.target.value,
                }));
              }}
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
            }}
          >
            <IconButton onClick={() => createUpdatePublicAssessment()}>
              <CheckIcon />
            </IconButton>
          </Box>
        </Box>
      </Modal>
    </div>
  );
}
